import React from 'react';
import CONFIG from '../../../config';
import axios from "axios";
import { useNavigate } from 'react-router-dom';

import TrelloColumn from './TrelloColumn'


function TrelloBoard({ state, setState, cols }) {
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    axios.get(CONFIG.API_URL + '/api/me', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;
          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 401:
            navigate('/connexion');
            break;
          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);

  return (
    <>
      <div className={'m-6 grid grid-cols-6 gap-x-4 w-100'}>
        {Object.keys(cols).map(key => <TrelloColumn key={key} state={state} setState={setState} col={key} content={cols[key]} user={user} ></TrelloColumn>)}
      </div>
    </>
  );
}

export default TrelloBoard;